/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import BasicDropDownFullLink from '../../../Form/BasicDropDowns/BasicDropDownFullLink';

const FullLink = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'FullLink',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    linkTo: '',
    icon: '',
    hasPaddingLeft: false,
    textColor: 'black',
  };

  const icons = ['icon-arrow-right-fine', 'icon-download1', 'icon-arrow-right', 'icon-arrow-right-round', 'icon-arrow-right-solid', 'icon-file'];
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isPaddingLeftOn, setPaddingLeftOn] = useState(false);
  const [isColorWhite, setColorWhite] = useState(false);

  useEffect(() => {
    if (index >= 0 && components.length) {
      const { component } = components[index];
      const fontColor = isColorWhite ? 'white' : 'black';

      const comp = {
        ...component,
        textColor: fontColor,
      };
      setState(comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  }, [isColorWhite]);


  const inputHandler = (e) => {
    const { value, name, lang } = e.target;

    const { component } = components[index];
    let comp = {};
    if (name === 'text') {
      comp = {
        ...component,
        [name]: {
          ...component[name],
          [lang.toLowerCase()]: value,
        },
      };
    } else {
      comp = {
        ...component,
        [name]: value,
      };
    }
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setState(component);
        if (component.hasOwnProperty('hasPaddingLeft')) setPaddingLeftOn(component.hasPaddingLeft);
        if (component.hasOwnProperty('textColor')) setColorWhite(component.textColor === 'white' || false);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const storeOption = (option) => {
    const { component } = components[index];
    const comp = {
      ...component,
      icon: option,
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const handleComponentBooleans = (e) => {
    const { name } = e.target;
    const { component } = components[index];
    let comp;
    if (name === 'hasPaddingLeft') {
      comp = {
        ...component,
        hasPaddingLeft: !isPaddingLeftOn,
      };
      setPaddingLeftOn(prevState => !prevState);
    } else {
      comp = {
        ...component,
        textColor: isColorWhite ? 'white' : 'black',
      };
      setColorWhite(prevState => !prevState);
    }

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  return (
    <div className="w-full px-4 bg-greyFilter rounded-lg flex flex-col">
      <div className="flex flex-row items-center w-full pb-1">
        {languages.map(lang => (
          <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'}  w-1/3 px-4 bg-greyFilter pl-10 pr-2 w-42% self-center`}>
            <label htmlFor="text" className="flex flex-col font-americaMonoRegular text-xs uppercase text-black">
              Text
              <input className="mt-1 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="text" lang={lang} type="text" value={state.text[lang.toLowerCase()]} readOnly={reusableComponent && reusableComponent} />
            </label>
          </div>
        ))}
        <label htmlFor="url" className="flex flex-col font-americaMonoRegular text-xs uppercase text-black w-full mx-1 mt-1 xxl1:w-1/2">
          Url
          <input className="mt-1 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="linkTo" type="text" value={state.linkTo} readOnly={reusableComponent && reusableComponent} />
        </label>
      </div>
      <div className="w-full flex pl-10">
        <label htmlFor="icon" className="flex flex-col font-americaMonoRegular text-xs uppercase text-black pr-2 mt-1">
          Icon
          <div className="mt-1 mb-2">
            <BasicDropDownFullLink title="Icon Options" message="No options available" suggestions={icons} storeOption={storeOption} state={state} style="w-400px" />
          </div>
        </label>
        <label htmlFor="paddingLeft" className="flex flex-col font-americaMonoRegular text-xs uppercase text-black w-full mx-1 mt-1 xxl1:w-1/2">
          Insert Padding Left
          {/* <input className="mt-1 font-americaMonoRegular p-2 bg-white outline-none w-full rounded-full" onChange={inputHandler} name="linkTo" type="text" value={state.linkTo} readOnly={reusableComponent && reusableComponent} /> */}
          <div className="pb-0 mt-6px ml-1">
            <label className="switch-no-text mb-0 pb-0 h-6">
              <input name="hasPaddingLeft" className="switch-no-text" checked={isPaddingLeftOn} onChange={handleComponentBooleans} type="checkbox" />
              <div className="switch-slider-no-text btn-gr switch-round" />
            </label>
          </div>
        </label>
        <label htmlFor="textWhite" className="flex flex-col font-americaMonoRegular text-xs uppercase text-black w-full mx-1 mt-1 xxl1:w-1/2">
          Text Color
          <div className="pb-0 mt-6px ml-1">
            <label className="switch mb-0 pb-0 h-6">
              <input name="isTextWhite" className="switch" checked={isColorWhite} onChange={handleComponentBooleans} type="checkbox" />
              <div className="switch-slider btn-bw switch-round" />
            </label>
          </div>
        </label>
      </div>
    </div>
  );
};

FullLink.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
FullLink.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default FullLink;
